export function openChat() {
  if (window.zE) {
    window.zE('messenger', 'show')
    window.zE('messenger', 'open')
  }
}
